import { safeStorage } from "@utils/safeStorage"
import { useHydrating } from "eddev/routing"
import { useState } from "react"

export function useDismissable(key: string, durationHours: number) {
  let storageKey = "dismissed-" + key
  const [dismissed, setDismissed] = useState(() => {
    if (env.client) {
      const dismissedAt = Number(safeStorage.getItem(storageKey))
      if (dismissedAt) {
        return Date.now() - dismissedAt < durationHours * 60 * 60 * 1000
      }
    }
    return false
  })
  const reallyDismissed = useHydrating() ? false : dismissed

  const onDismiss = () => {
    safeStorage.setItem(storageKey, String(Date.now()))
    setDismissed(true)
  }

  const reset = () => {
    safeStorage.removeItem(storageKey)
    setDismissed(false)
  }

  return { dismissed: reallyDismissed, onDismiss, reset }
}
